import StorageKeys from 'enum/storages.enum';

const keys = StorageKeys.Keys;

function setItem(key, payload) {
  if (typeof key === 'string') {
    localStorage.setItem(key, JSON.stringify(payload));
  }
}

function removeItem(key) {
  localStorage.removeItem(key);
}

function getItem(key) {
  var value = localStorage.getItem(key);

  if (typeof value !== 'undefined') {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
}
function removeProfileCategory() {
  const profileCategories = getItem(StorageKeys.Keys.PROFILECATEGORY);

  if (profileCategories !== null && profileCategories.length > 0) {
    profileCategories.forEach((element) => {
      localStorage.removeItem(StorageKeys.Keys.PROFILE + element.id);
    });
  } else {
    localStorage.removeItem('profileCategory');
  }
}

function clearCacheForRemoteConfig(excludeKeys = []) {
  removeProfileCategory();
  const keysForStorage = Object.values(keys).filter((key) => !excludeKeys.includes(key));
  keysForStorage.forEach((key) => {
    localStorage.removeItem(key);
  });
}

const obj = {
  setItem,
  getItem,
  removeItem,
  clearCacheForRemoteConfig,
};

export default obj;
